const Account = () => import('@/pages/Account')
const Account_ResponsibleAccount = () => import('@/pages/Account/ResponsibleAccount')
const Account_KeepAccounts = () => import('@/pages/Account/KeepAccounts')
const Account_CheckAccounts = () => import('@/pages/Account/checkAccounts')
const Charge = () => import('@/pages/Charge')
const Charge_Registration = () => import('@/pages/Charge/Registration')
const Invoice = () => import('@/pages/Invoice')
const Invoice_ClearanceRegister = () => import('@/pages/Invoice/ClearanceRegister')
const Project = () => import('@/pages/Project')
const Project_ResponsibleList = () => import('@/pages/Project/ResponsibleList')
const Setting = () => import('@/pages/Setting')
const Setting_Company = () => import('@/pages/Setting/CompanySetting')
const Setting_Personal = () => import('@/pages/Setting/PersonalSetting')
// const Setting_Team = () => import('@/pages/Setting/TeamSetting')
const Setting_Team = () => import('@/pages/Setting/NewTeamSetting')
const Setting_Role = () => import('@/pages/Setting/RoleSetting')
const Setting_Job = () => import('@/pages/Setting/JobSetting')
const Setting_Position = () => import('@/pages/Setting/PositionSetting')
const Setting_Teamer = () => import('@/pages/Setting/TeamerSetting')
const Setting_MemberSetting = () => import('@/pages/Setting/MemberSettingForm')
const Setting_Subject = () => import('@/pages/Setting/SubjectSetting')
const Setting_Permission = () => import('@/pages/Setting/PermissionSetting')
const Setting_HandleRecord = () => import('@/pages/Setting/HandleRecord')
const Setting_Management = () => import('@/pages/Setting/Management')
const Setting_HelpCenterList = () => import('@/pages/Setting/HelpCenterList')
const Setting_ServerSetting = () => import('@/pages/Setting/ServerSetting')
const Setting_DeviceGrantSetting = () => import('@/pages/Setting/DeviceGrantSetting')
const Stat = () => import('@/pages/Stat')
const Stat_AgentCustomer = () => import('@/pages/Stat/AgentCustomer')
const Tax = () => import('@/pages/Tax')
const Tax_DeclareTaxPreview = () => import('@/pages/Tax/DeclareTaxPreview')
const HelpCenter = () => import('@/pages/HelpCenter')
const HelpCenter_HelpDoc = () => import('@/pages/HelpCenter/HelpDocPage')
const HelpCenter_HelpQuestionPage = () => import('@/pages/HelpCenter/HelpQuestionPage')
const HelpCenter_AnswerQuestionPage = () => import('@/pages/HelpCenter/AnswerQuestionPage')
const HelpCenter_HelpAskPage = () => import('@/pages/HelpCenter/HelpAskPage')
const Message = () => import('@/pages/Message')
const Message_Center = () => import('@/pages/Message/MessagePage')
const Setting_Config = () => import('@/pages/Setting/Config')
const TaskCenter = () => import('@/pages/TaskCenter')
const MissionCenter = () => import('@/pages/taskCenter/missionCenter')
const DisplayBoard = () => import('@/pages/DisplayBoard')
const DisplayBoard_Detail = () => import('@/pages/DisplayBoard/WorkloadDetail')
const DisplayBoard_Collect = () => import('@/pages/DisplayBoard/WorkloadCollect')
const HelpCenter_DemandProblem = () => import('@/pages/HelpCenter/DemandProblem')
const Salary = () => import('@/pages/Salary')
const Salary_Record = () => import('@/pages/Salary/RecordSummary')
const Salary_Achievement = () => import('@/pages/Salary/Achievement')
const Salary_Staff = () => import('@/pages/Salary/StaffAchievement')

const Setting_Dictionary = () => import('@/pages/Setting/DictionarySetting')

const Salary_Commision = () => import('@/pages/Salary/RecommendCommision')
const Finance = () => import('@/pages/Finance')
const Finance_CashExpense = () => import('@/pages/Finance/CashierExpense')
const Finance_Fund = () => import('@/pages/Finance/FundDetail')
const Finance_Config = () => import('@/pages/Finance/CashierConfig')
const Finance_Income = () => import('@/pages/Salary/SalaryCalculation')

const Finance_Document = () => import('@/pages/Finance/DocumentSetting')
const Finance_Wage = () => import('@/pages/Finance/WageTable')
const Finance_BillReceivable = () => import('@/pages/Finance/BillReceivable')

export default {
  Account,
  Account_ResponsibleAccount,
  Account_KeepAccounts,
  Account_CheckAccounts,
  Charge,
  Charge_Registration,
  Invoice,
  Invoice_ClearanceRegister,
  Project,
  Project_ResponsibleList,
  Setting,
  Setting_Company,
  Setting_Personal,
  Setting_Team,
  Setting_Position,
  Setting_Job,
  Setting_Role,
  Setting_Teamer,
  Setting_MemberSetting,
  Setting_Subject,
  Setting_Permission,
  Setting_HandleRecord,
  Setting_Management,
  Setting_HelpCenterList,
  Setting_DeviceGrantSetting,
  Stat,
  Stat_AgentCustomer,
  Tax,
  Tax_DeclareTaxPreview,
  HelpCenter,
  HelpCenter_HelpDoc,
  HelpCenter_HelpQuestionPage,
  HelpCenter_AnswerQuestionPage,
  HelpCenter_HelpAskPage,
  Message,
  Message_Center,
  Setting_Config,
  TaskCenter,
  MissionCenter,
  Setting_ServerSetting,
  DisplayBoard_Detail,
  DisplayBoard_Collect,
  DisplayBoard,
  HelpCenter_DemandProblem,
  Salary,
  Salary_Record,
  Salary_Achievement,
  Salary_Staff,
  Setting_Dictionary,
  Salary_Commision,
  Finance,
  Finance_CashExpense,
  Finance_Fund,
  Finance_Config,
  Finance_Income,
  Finance_Document,
  Finance_Wage,
  Finance_BillReceivable
}


// WEBPACK FOOTER //
// ./src/router/comp.js